import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutEuromonitorComponent } from './about-euromonitor.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
      AboutEuromonitorComponent
    ],
    exports: [
      AboutEuromonitorComponent
    ],
})
export class AboutEuromonitorModule {}
